import "@/styles/styles.ts";

import { initDev } from "@/dev/initDev.ts";
import { beginMockDbInit } from "@/mock-api/msw/mswInit.ts";
import Root from "@/root.tsx";
import { applyUrlParamOverrides } from "@/urlParamOverrides.ts";
import ReactDOM from "react-dom/client";

function main() {
    initDev();

    applyUrlParamOverrides();

    beginMockDbInit({ persistent: true, mockDbOptions: {} });

    ReactDOM.createRoot(document.getElementById("root")!).render(<Root />);
}

main();
